import React from "react";
import {Box, Grid, TextField, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

interface PrescriptionCardFieldProps {
    title: string,
    value: string,
    measurementUnits?: string,
}

const useStyles = makeStyles({
    formItem: {
        marginBottom: "1em",
    }
});

const PrescriptionCardField: React.FC<PrescriptionCardFieldProps> = (
    {
        title,
        value,
        measurementUnits,
    }) => {
    const classes = useStyles();

    return (
        <>
            <Grid item xs={12}>
                <Box marginBottom="15px">
                    <Typography variant="h4">{title}</Typography>
                </Box>
            </Grid>
            <Grid item xs={measurementUnits? 10: 12} className={classes.formItem}>
                <TextField
                    variant="outlined"
                    fullWidth
                    disabled
                    type="text"
                    value={value}
                    InputProps={{
                        style: {
                            color: "rgba(0, 0, 0, 0.5)",
                            fontStyle: "italic"
                        }
                    }}
                />
            </Grid>
            {measurementUnits
            &&
            <Grid item xs={2} className={classes.formItem}>
                <Box display="flex">
                    <Typography style={{margin: "auto"}} variant="h4">{measurementUnits}</Typography>
                </Box>
            </Grid>}
        </>
    );
};
export default PrescriptionCardField;

